import RecentProductsPreview from './RecentProductsPreview'

export default RecentProductsPreview